import { addOpacityToHex } from '@utils/functions';
import { Customization } from '@utils/interfaces';

export function obTokensValues(colorConfig?: Customization) {
  return {
    actionColorBgBrand: colorConfig?.primaryColor || 'rgba(38, 94, 241, 1)',
    actionColorBgBrandA0: 'rgba(38, 94, 241, 0)',
    actionColorBgBrandA0Inverse: 'rgba(255, 255, 255, 0)',
    actionColorBgBrandAlpha: 'rgba(38, 94, 241, 0.1)',
    actionColorBgBrandAlphaInverse: 'rgba(255, 255, 255, 0.1)',
    actionColorBgBrandHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    actionColorBgBrandInverse: 'rgba(52, 68, 81, 1)',
    actionColorBgBrandInverseHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    actionColorBgDarkA0: 'rgba(0, 22, 37, 0)',
    actionColorBgDarkA20: 'rgba(0, 22, 37, 0.2)',
    actionColorBgDarkA50: 'rgba(0, 22, 37, 0.5)',
    actionColorBgDisabled: 'rgba(245, 246, 248, 1)',
    actionColorBgDisabledInverse: 'rgba(245, 246, 248, 1)',
    actionColorBgLightA0: 'rgba(255, 255, 255, 0)',
    actionColorBgLightA20: 'rgba(255, 255, 255, 0.2)',
    actionColorBgLightA50: 'rgba(255, 255, 255, 0.5)',
    actionColorBgSecondary: 'rgba(255, 255, 255, 1)',
    actionColorBgSecondaryHover: 'rgba(237, 243, 253, 1)',
    actionColorBgSecondaryInverse: 'rgba(0, 22, 37, 1)',
    actionColorBgSecondaryInverseHover: 'rgba(52, 68, 81, 1)',
    actionColorBgTertiary: 'rgba(0, 22, 37, 1)',
    actionColorBgTertiaryHover: 'rgba(52, 68, 81, 1)',
    actionColorBgTertiaryInverse: 'rgba(255, 255, 255, 1)',
    actionColorBgTertiaryInverseHover: 'rgba(237, 243, 253, 1)',
    actionColorBordersBrand: 'rgba(52, 68, 81, 1)',
    actionColorBordersBrandA0: 'rgba(38, 94, 241, 0)',
    actionColorBordersBrandAlpha: 'rgba(38, 94, 241, 0.1)',
    actionColorBordersBrandHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    actionColorBordersBrandInverse: 'rgba(255, 255, 255, 1)',
    actionColorBordersBrandInverseHover: 'rgba(237, 243, 253, 1)',
    actionColorBordersDarkA0: 'rgba(0, 22, 37, 0)',
    actionColorBordersDarkA20: 'rgba(0, 22, 37, 0.2)',
    actionColorBordersDarkA50: 'rgba(0, 22, 37, 0.5)',
    actionColorBordersDisabled: 'rgba(174, 182, 187, 1)',
    actionColorBordersDisabledInverse: 'rgba(174, 182, 187, 1)',
    actionColorBordersLightA0: 'rgba(255, 255, 255, 0)',
    actionColorBordersLightA20: 'rgba(255, 255, 255, 0.2)',
    actionColorBordersLightA50: 'rgba(255, 255, 255, 0.5)',
    actionColorBordersLink: 'rgba(0, 22, 37, 1)',
    actionColorBordersLinkHover: 'rgba(52, 68, 81, 1)',
    actionColorBordersLinkHoverInverse: 'rgba(237, 243, 253, 1)',
    actionColorBordersLinkInverse: 'rgba(255, 255, 255, 1)',
    actionColorBordersSecondary: 'rgba(255, 255, 255, 1)',
    actionColorBordersSecondaryHover: 'rgba(237, 243, 253, 1)',
    actionColorBordersSecondaryInverse: 'rgba(0, 22, 37, 1)',
    actionColorBordersSecondaryInverseHover: 'rgba(52, 68, 81, 1)',
    actionColorBordersTertiary:
      colorConfig?.secondaryColor || 'rgba(0, 22, 37, 1)',
    actionColorBordersTertiaryHover: 'rgba(52, 68, 81, 1)',
    actionColorBordersTertiaryInverse: 'rgba(255, 255, 255, 1)',
    actionColorBordersTertiaryInverseHover: 'rgba(237, 243, 253, 1)',
    actionColorTextBrand: 'rgba(255, 255, 255, 1)',
    actionColorTextBrandHover: 'rgba(255, 255, 255, 1)',
    actionColorTextBrandInverse: 'rgba(255, 255, 255, 1)',
    actionColorTextBrandInverseHover: 'rgba(255, 255, 255, 1)',
    actionColorTextDisabled: 'rgba(174, 182, 187, 1)',
    actionColorTextDisabledInverse: 'rgba(70, 87, 113, 1)',
    actionColorTextLink: 'rgba(0, 22, 37, 1)',
    actionColorTextLinkHover: 'rgba(52, 68, 81, 1)',
    actionColorTextLinkHoverInverse: 'rgba(237, 243, 253, 1)',
    actionColorTextLinkInverse: 'rgba(255, 255, 255, 1)',
    actionColorTextLinkSecondary: 'rgba(255, 255, 255, 1)',
    actionColorTextLinkSecondaryHover: 'rgba(255, 255, 255, 1)',
    actionColorTextLinkSecondaryHoverInverse: 'rgba(0, 22, 37, 1)',
    actionColorTextLinkSecondaryInverse: 'rgba(0, 22, 37, 1)',
    actionColorTextLinkTertiary:
      colorConfig?.secondaryColor || 'rgba(0, 22, 37, 1)',
    actionColorTextLinkTertiaryHover: 'rgba(52, 68, 81, 1)',
    actionColorTextLinkTertiaryHoverInverse: 'rgba(237, 243, 253, 1)',
    actionColorTextLinkTertiaryInverse: 'rgba(255, 255, 255, 1)',
    actionColorTextSecondary: 'rgba(0, 22, 37, 1)',
    actionColorTextSecondaryHover: 'rgba(52, 68, 81, 1)',
    actionColorTextSecondaryInverse: 'rgba(255, 255, 255, 1)',
    actionColorTextSecondaryInverseHover: 'rgba(255, 255, 255, 1)',
    actionColorTextTertiary: 'rgba(255, 255, 255, 1)',
    actionColorTextTertiaryHover: 'rgba(255, 255, 255, 1)',
    actionColorTextTertiaryInverse: 'rgba(0, 22, 37, 1)',
    actionColorTextTertiaryInverseHover: 'rgba(52, 68, 81, 1)',
    bgColorAlphaBrandA0: 'rgba(38, 94, 241, 0)',
    bgColorAlphaBrandPrimary: 'rgba(38, 94, 241, 0.3)',
    bgColorAlphaDarkA0: 'rgba(0, 0, 0, 0)',
    bgColorAlphaDarkA20: 'rgba(0, 0, 0, 0.2)',
    bgColorAlphaDarkA50: 'rgba(0, 0, 0, 0.5)',
    bgColorAlphaInverseBrandA0: 'rgba(38, 94, 241, 0)',
    bgColorAlphaInverseBrandPrimary: 'rgba(38, 94, 241, 0.1)',
    bgColorAlphaLightA0: 'rgba(255, 255, 255, 0)',
    bgColorAlphaLightA20: 'rgba(255, 255, 255, 0.2)',
    bgColorAlphaLightA50: 'rgba(255, 255, 255, 0.6)',
    bgColorBaseDefault: 'rgba(255, 255, 255, 1)',
    bgColorBaseInverseDefault: 'rgba(0, 22, 37, 1)',
    bgColorBaseInverseSecondary: 'rgba(70, 87, 113, 1)',
    bgColorBaseInverseTertiary: 'rgba(174, 182, 187, 1)',
    bgColorBaseSecondary: addOpacityToHex(
      'rgba(245, 246, 248, 1)',
      0.1,
      colorConfig?.primaryColor,
    ),
    bgColorBaseTertiary: 'rgba(174, 182, 187, 1)',
    bgColorBrandInversePrimary: 'rgba(52, 68, 81, 1)',
    bgColorBrandInversePrimaryHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bgColorBrandInverseSecondary: 'rgba(255, 255, 255, 1)',
    bgColorBrandInverseSecondaryHover: 'rgba(217, 228, 245, 1)',
    bgColorBrandInverseTertiary: 'rgba(237, 243, 253, 1)',
    bgColorBrandInverseTertiaryHover: 'rgba(237, 243, 253, 1)',
    bgColorBrandPrimary: 'rgba(52, 68, 81, 1)',
    bgColorBrandPrimaryHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bgColorBrandSecondary: 'rgba(0, 22, 37, 1)',
    bgColorBrandSecondaryHover: 'rgba(52, 68, 81, 1)',
    bgColorBrandTertiary: 'rgba(237, 243, 253, 1)',
    bgColorBrandTertiaryHover: 'rgba(237, 243, 253, 1)',
    bgColorFunctionalDisabled: 'rgba(229, 232, 237, 1)',
    bgColorFunctionalError: 'rgba(255, 223, 233, 1)',
    bgColorFunctionalInfo: 'rgba(237, 243, 253, 1)',
    bgColorFunctionalInverseDisabled: 'rgba(229, 232, 237, 1)',
    bgColorFunctionalInverseError: 'rgba(255, 223, 233, 1)',
    bgColorFunctionalInverseInfo: 'rgba(237, 243, 253, 1)',
    bgColorFunctionalInverseSuccess: 'rgba(226, 252, 229, 1)',
    bgColorFunctionalInverseWarning: 'rgba(255, 248, 229, 1)',
    bgColorFunctionalSuccess: 'rgba(226, 252, 229, 1)',
    bgColorFunctionalWarning: 'rgba(255, 248, 229, 1)',
    bgColorPromoInverseDefaultG1: 'rgba(151, 71, 255, 1)',
    bgColorPromoDefaultG1: 'rgba(52, 68, 81, 1)',
    bgColorPromoDefaultG2: 'rgba(151, 71, 255, 1)',
    bgColorPromoInverseDefaultG2: 'rgba(52, 68, 81, 1)',
    bgColorPromoInverseSecondaryG1: 'rgba(151, 71, 255, 1)',
    bgColorPromoInverseSecondaryG2: 'rgba(105, 81, 249, 1)',
    bgColorPromoInverseTertiaryG1: 'rgba(240, 243, 253, 1)',
    bgColorPromoInverseTertiaryG2: 'rgba(196, 209, 245, 1)',
    bgColorPromoSecondaryG1: 'rgba(151, 71, 255, 1)',
    bgColorPromoSecondaryG2: 'rgba(105, 81, 249, 1)',
    bgColorPromoTertiaryG1: 'rgba(240, 243, 253, 1)',
    bgColorPromoTertiaryG2: 'rgba(196, 209, 245, 1)',
    bordersColorBrandPrimary: 'rgba(52, 68, 81, 1)',
    bordersColorBrandPrimaryHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bordersColorBrandPrimaryHoverInverse: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bordersColorBrandPrimaryInverse: 'rgba(52, 68, 81, 1)',
    bordersColorBrandSecondary: 'rgba(52, 68, 81, 1)',
    bordersColorBrandSecondaryHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bordersColorBrandSecondaryHoverInverse: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bordersColorBrandSecondaryInverse: 'rgba(52, 68, 81, 1)',
    bordersColorBrandTertiary: 'rgba(52, 68, 81, 1)',
    bordersColorBrandTertiaryHover: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bordersColorBrandTertiaryHoverInverse: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    bordersColorBrandTertiaryInverse: 'rgba(52, 68, 81, 1)',
    bordersColorFunctionalDisabled: 'rgba(118, 118, 118, 1)',
    bordersColorFunctionalDisabledInverse: 'rgba(118, 118, 118, 1)',
    bordersColorFunctionalError: 'rgba(187, 37, 26, 1)',
    bordersColorFunctionalErrorInverse: 'rgba(255, 175, 199, 1)',
    bordersColorFunctionalFocus: 'rgba(3, 84, 166, 1)',
    bordersColorFunctionalFocusInverse: 'rgba(121, 181, 240, 1)',
    bordersColorFunctionalInfo: 'rgba(217, 228, 245, 1)',
    bordersColorFunctionalInfoInverse: 'rgba(217, 228, 245, 1)',
    bordersColorFunctionalSuccess: 'rgba(35, 174, 49, 0.2)',
    bordersColorFunctionalSuccessInverse: 'rgba(35, 174, 49, 0.2)',
    bordersColorFunctionalWarning: 'rgba(233, 140, 0, 0.3)',
    bordersColorFunctionalWarningInverse: 'rgba(233, 140, 0, 0.3)',
    bordersColorNeutralDefault: 'rgba(255, 255, 255, 1)',
    bordersColorNeutralInverseDefault: 'rgba(0, 0, 0, 1)',
    bordersColorNeutralInverseSecondary: 'rgba(64, 64, 64, 1)',
    bordersColorNeutralInverseTertiary: 'rgba(129, 129, 129, 1)',
    bordersColorNeutralSecondary: 'rgba(216, 216, 216, 1)',
    bordersColorNeutralTertiary: 'rgba(118, 118, 118, 1)',
    textColorBaseDefault: 'rgba(0, 22, 37, 1)',
    textColorBaseInverseDefault: 'rgba(255, 255, 255, 1)',
    textColorBaseInverseSecondary: 'rgba(245, 246, 248, 1)',
    textColorBaseInverseTertiary: 'rgba(229, 232, 237, 1)',
    textColorBaseSecondary: 'rgba(52, 68, 81, 1)',
    textColorBaseTertiary: 'rgba(70, 87, 113, 1)',
    textColorBrandPrimary: 'rgba(38, 94, 241, 1)',
    textColorBrandPrimaryInverse: 'rgba(52, 68, 81, 1)',
    textColorBrandPromo1: 'rgba(255, 255, 255, 1)',
    textColorBrandPromo1Inverse: 'rgba(52, 68, 81, 1)',
    textColorBrandPromo2: 'rgba(52, 68, 81, 1)',
    textColorBrandPromo2Inverse: 'rgba(255, 255, 255, 1)',
    textColorBrandPromo3: 'rgba(52, 68, 81, 1)',
    textColorBrandPromo3Inverse: 'rgba(52, 68, 81, 1)',
    textColorBrandPromo4: 'rgba(255, 255, 255, 1)',
    textColorBrandPromo4Inverse: 'rgba(255, 255, 255, 1)',
    textColorBrandSecondary: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    textColorBrandSecondaryInverse: addOpacityToHex(
      'rgba(0, 72, 212, 1)',
      0.8,
      colorConfig?.primaryColor,
    ),
    textColorBrandTertiary: 'rgba(52, 68, 81, 1)',
    textColorBrandTertiaryInverse: 'rgba(52, 68, 81, 1)',
    textColorFunctionalDisabled: 'rgba(118, 118, 118, 1)',
    textColorFunctionalDisabledInverse: 'rgba(172, 172, 172, 1)',
    textColorFunctionalError: 'rgba(187, 37, 26, 1)',
    textColorFunctionalErrorInverse: 'rgba(255, 139, 136, 1)',
    textColorFunctionalInfo: 'rgba(20, 101, 180, 1)',
    textColorFunctionalInfoInverse: 'rgba(121, 181, 240, 1)',
    textColorFunctionalInverseLink: 'rgba(3, 97, 191, 1)',
    textColorFunctionalLink: 'rgba(3, 84, 166, 1)',
    textColorFunctionalLinkHover: 'rgba(1, 51, 101, 1)',
    textColorFunctionalLinkHoverInverse: 'rgba(1, 64, 126, 1)',
    textColorFunctionalSuccess: 'rgba(36, 117, 52, 1)',
    textColorFunctionalSuccessInverse: 'rgba(106, 192, 8, 1)',
    textColorFunctionalWarning: 'rgba(182, 132, 5, 1)',
    textColorFunctionalWarningInverse: 'rgba(249, 187, 30, 1)',
    actionBorderStrokeDefault: '0.0625rem',
    actionBorderStrokeHover: '0.0625rem',
    actionBorderRadius: '0.5rem',
    actionMBottomSm: '0.625rem',
    actionMTopSm: '0.625rem',
    actionMBottomMd: '0.75rem',
    actionMLeftLg: '0.75rem',
    actionMLeftMd: '0.75rem',
    actionMLeftSm: '0.75rem',
    actionMRightLg: '0.75rem',
    actionMRightMd: '0.75rem',
    actionMRightSm: '0.75rem',
    actionMTopMd: '0.75rem',
    actionMBottomLg: '1rem',
    actionMTopLg: '1rem',
    actionPLg: '0.5rem',
    actionPMd: '0.5rem',
    actionPSm: '0.5rem',
    bordersRadiusNone: '0rem',
    bordersRadiusSm: '0.375rem',
    bordersRadiusMd: '0.5rem',
    bordersRadiusLg: '1rem',
    bordersRadiusXl: '2rem',
    bordersRadiusRound: '62.4375rem',
    bordersStrokeNone: '0rem',
    bordersStrokeThinnest: '0.125rem',
    bordersStrokeThin: '0.1875rem',
    bordersStrokeMedium: '0.25rem',
    bordersStrokeStrong: '0.3125rem',
    deviceDeskMNone: '0rem',
    deviceDeskMLrSm: '1rem',
    deviceDeskMTbSm: '1.5rem',
    deviceDeskMLrBase: '4rem',
    deviceDeskMTbBase: '4rem',
    deviceDeskMTbLg: '5rem',
    deviceDeskMLrLg: '11rem',
    deviceDeskPNone: '0rem',
    deviceDeskPXs: '0.5rem',
    deviceDeskPSm: '1rem',
    deviceDeskPBase: '1.5rem',
    deviceDeskPLg: '2.5rem',
    deviceDeskRRadius: '0.375rem',
    deviceMobMNone: '0rem',
    deviceMobMLrBase: '1rem',
    deviceMobMLrLg: '1rem',
    deviceMobMLrSm: '1rem',
    deviceMobMTbSm: '1rem',
    deviceMobMTbBase: '2.5rem',
    deviceMobMTbLg: '4rem',
    deviceMobPNone: '0rem',
    deviceMobPXs: '0.5rem',
    deviceMobPSm: '1rem',
    deviceMobPBase: '1.5rem',
    deviceMobPLg: '2.5rem',
    deviceMobRRadius: '0.375rem',
    deviceTabMNone: '0rem',
    deviceTabMTbSm: '1rem',
    deviceTabMLrBase: '2rem',
    deviceTabMLrSm: '2rem',
    deviceTabMTbBase: '2rem',
    deviceTabMTbLg: '3rem',
    deviceTabMLrLg: '5rem',
    deviceTabPNone: '0rem',
    deviceTabPXs: '0.5rem',
    deviceTabPSm: '1rem',
    deviceTabPBase: '1.5rem',
    deviceTabPLg: '2rem',
    deviceTabRRadiusLandscape: '0.5rem',
    deviceTabRRadiusPortrait: '0.5rem',
    screenSizeMobile: '23.4375rem',
    screenSizeTabletPortrait: '48rem',
    screenSizeTabletLandscape: '64rem',
    screenSizeDesktop: '90rem',
    text2xlKerning: '0rem',
    text2xlSize: '1.5rem',
    text2xlLineHeight: '2.125rem',
    text3xlKerning: '0rem',
    text3xlSize: '2rem',
    text3xlLineHeight: '2.625rem',
    text4xlKerning: '0rem',
    text4xlSize: '2.5rem',
    text4xlLineHeight: '3.25rem',
    text5xlKerning: '0rem',
    text5xlSize: '4rem',
    text5xlLineHeight: '4.8125rem',
    text6xlKerning: '0rem',
    text6xlSize: '5rem',
    text6xlLineHeight: '6rem',
    text7xlKerning: '0rem',
    text7xlSize: '7.5rem',
    text7xlLineHeight: '9rem',
    textCTABigKerning: '0rem',
    textCTABigLineHeight: '1rem',
    textCTABigSize: '1rem',
    textCTAMediumKerning: '0rem',
    textCTAMediumSize: '0.875rem',
    textCTAMediumLineHeight: '1rem',
    textCTASmallKerning: '0rem',
    textCTASmallSize: '0.75rem',
    textCTASmallLineHeight: '1rem',
    textBaseKernng: '0rem',
    textBaseSize: '1rem',
    textBaseLineHeight: '1.5rem',
    textH1DeskKerning: '0.0125rem',
    textH1DeskSize: '2rem',
    textH1DeskLineHeight: '2.25rem',
    textH1MobKerning: '0.0125rem',
    textH1MobSize: '2rem',
    textH1MobLineHeight: '2.25rem',
    textH1TabKerning: '0.0125rem',
    textH1TabSize: '2rem',
    textH1TabLineHeight: '2.25rem',
    textH2DeskKerning: '0.0125rem',
    textH2DeskSize: '1.5rem',
    textH2DeskLineHeight: '2rem',
    textH2MobKerning: '0.0125rem',
    textH2MobSize: '1.5rem',
    textH2MobLineHeight: '2rem',
    textH2TabKerning: '0.0125rem',
    textH2TabSize: '1.5rem',
    textH2TabLineHeight: '2rem',
    textH3DeskKerning: '0.0125rem',
    textH3DeskSize: '1.125rem',
    textH3DeskLineHeight: '1.5rem',
    textH3MobKerning: '0.0125rem',
    textH3MobSize: '1.125rem',
    textH3MobLineHeight: '1.5rem',
    textH3TabKerning: '0.0125rem',
    textH3TabSize: '1.125rem',
    textH3TabLineHeight: '1.5rem',
    textH4DeskKerning: '0.0125rem',
    textH4DeskSize: '1rem',
    textH4DeskLineHeight: '1.25rem',
    textH4MobKerning: '0.0125rem',
    textH4MobSize: '1rem',
    textH4MobLineHeight: '1.25rem',
    textH4TabKerning: '0.0125rem',
    textH4TabSize: '1rem',
    textH4TabLineHeight: '1.25rem',
    textH5DeskKerning: '0.0125rem',
    textH5DeskSize: '1rem',
    textH5DeskLineHeight: '1.25rem',
    textH5MobKerning: '0.0125rem',
    textH5MobSize: '1rem',
    textH5MobLineHeight: '1.25rem',
    textH5TabKerning: '0.0125rem',
    textH5TabSize: '1rem',
    textH5TabLineHeight: '1.25rem',
    textH6DeskKerning: '0.0125rem',
    textH6DeskSize: '0.625rem',
    textH6DeskLineHeight: '1.25rem',
    textH6MobKerning: '0.0125rem',
    textH6MobSize: '0.625rem',
    textH6MobLineHeight: '1.25rem',
    textH6TabKerning: '0.0125rem',
    textH6TabSize: '0.625rem',
    textH6TabLineHeight: '1.25rem',
    textLgKerning: '0rem',
    textLgSize: '1.125rem',
    textLgLineHeight: '1.6875rem',
    textSmKerning: '0.0125rem',
    textSmSize: '0.875rem',
    textSmLineHeight: '1.25rem',
    textXlKerning: '0rem',
    textXlSize: '1.25rem',
    textXlLineHeight: '1.75rem',
    textXsKerning: '0.0125rem',
    textXsSize: '0.75rem',
    textXsLineHeight: '1.125rem',
    brandURL: 'helix.com',
    brandName: 'Vision X',
    brandingBadge: 'VisionX',
    brandingBrandFooter: 'VisionX',
    brandingBrandHeader: 'VisionX',
    brandingBrandLogo: 'VisionX Logo',
    brandingBrandPictogram: 'VisionX Logo',
    brandingFavicon: 'VisionX',
    brandingOff: 'Stroke',
    brandingProductImage: 'General assortment',
    text2xlFamily: 'Neue Haas Grotesk Text Std',
    text3xlFamily: 'Neue Haas Grotesk Text Std',
    text4xlFamily: 'Neue Haas Grotesk Text Std',
    text5xlFamily: 'Neue Haas Grotesk Text Std',
    text6xlFamily: 'Neue Haas Grotesk Text Std',
    text7xlFamily: 'Neue Haas Grotesk Text Std',
    textCTABigFamily: 'Neue Haas Grotesk Text Std',
    textCTABigWeight: '65 Medium',
    textCTAMediumFamily: 'Neue Haas Grotesk Text Std',
    textCTAMediumWeight: '65 Medium',
    textCTASmallFamily: 'Neue Haas Grotesk Text Std',
    textCTASmallWeight: '65 Medium',
    textBaseFamily: 'Neue Haas Grotesk Text Std',
    textCaseUppercase: 'uppercase',
    textDecorationStrikethrough: 'strikethrough',
    textDecorationUnderlined: 'underline',
    textH1Family: 'Maison Neue Ext',
    textH1Weight: 'Medium',
    textH2Family: 'Maison Neue Ext',
    textH2Weight: 'Medium',
    textH3Family: 'Maison Neue Ext',
    textH3Weight: 'Medium',
    textH4Family: 'Maison Neue Ext',
    textH4Weight: 'Medium',
    textH5Family: 'Neue Haas Grotesk Text Std',
    textH5Weight: '65 Medium',
    textH6Family: 'Neue Haas Grotesk Text Std',
    textH6Weight: '65 Medium',
    textLgFamily: 'Neue Haas Grotesk Text Std',
    textSmFamily: 'Neue Haas Grotesk Text Std',
    textWeightBold: '65 Medium',
    textWeightDefault: 'Regular',
    textXlFamily: 'Neue Haas Grotesk Text Std',
    textXsFamily: 'Neue Haas Grotesk Text Std',
  };
}
